import React from 'react';
import styles from './index.module.less';
import moment from 'moment';
import {
  Radio,
  Button,
  Row,
  Col,
  Card,
  Empty,
  Tooltip,
  Tag,
  Space
} from 'antd';

import SearchBar from '@/common/Content/searchBar';
import CustomTable from 'common/Content/CustomTable';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { history } from 'app/history';

import { useNavigate } from 'react-router-dom';

const filters = [
  /*  {
    name: 'Gift Received',
    value: ''
  },
  {
    name: 'Pending',
    value: 'pending'
  },
  {
    name: 'Accepted',
    value: 'accepted'
  },
  {
    name: 'Rejected',
    value: 'rejected'
  } */
];

function DeclarationFormPage({
  radiofilter,
  setRadiofilter,
  setTriggerFilter,
  page,
  setPage,
  pageSize,
  setPageSize,
  setSearchRequest,
  adminBulkGiftConfigs,
  adminBulkGiftConfigsLoading,
  pagination
}) {
  const navigate = useNavigate();

  // Helper function to check if current date is within the upload date range
  const isDateInRange = (upldFrmDate, upldToDate) => {
    if (!upldFrmDate || !upldToDate) {
      return false;
    }
    const currentDate = moment().startOf('day');
    const startDate = moment(upldFrmDate).startOf('day');
    const endDate = moment(upldToDate).startOf('day');
    return (
      currentDate.isSameOrAfter(startDate) &&
      currentDate.isSameOrBefore(endDate)
    );
  };

  const columns = [
    {
      title: 'Start Date',
      dataIndex: 'upldFrmDate',
      key: 'upldFrmDate',
      ellipsis: true,
      sorter: (a, b) => a?.upldFrmDate?.localeCompare(b?.upldFrmDate),
      render: (upldFrmDate) => {
        const formattedDate = upldFrmDate
          ? moment(upldFrmDate).format('DD MMM YYYY')
          : 'N/A';
        return (
          <>
            <Tooltip
              title={formattedDate}
              color={'white'}
              overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
              arrowPointAtCenter="false"
            >
              {formattedDate}
            </Tooltip>
          </>
        );
      }
    },
    {
      title: 'End Date',
      dataIndex: 'upldToDate',
      key: 'upldToDate',
      ellipsis: {
        showTitle: false
      },
      sorter: (a, b) => a?.upldToDate?.localeCompare(b?.upldToDate),
      render: (upldToDate) => {
        const formattedDate = upldToDate
          ? moment(upldToDate).format('DD MMM YYYY')
          : 'N/A';
        return (
          <>
            <Tooltip
              title={formattedDate}
              color={'white'}
              overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
              arrowPointAtCenter="false"
            >
              <span className={styles.text_transform}>{formattedDate}</span>
            </Tooltip>
          </>
        );
      }
    },
    {
      title: 'Fiscal Year',
      dataIndex: 'fiscalYear',
      key: 'fiscalYear',
      ellipsis: true,
      sorter: (a, b) => a?.fiscalYear?.localeCompare(b?.fiscalYear),
      render: (fiscalYear) => {
        return (
          <>
            <Tooltip
              title={fiscalYear}
              color={'white'}
              overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
              arrowPointAtCenter="false"
            >
              {fiscalYear === null || fiscalYear === '' ? 'N/A' : fiscalYear}
            </Tooltip>
          </>
        );
      }
    },
    {
      title: 'Project Site',
      dataIndex: 'ProjectSite',
      key: 'projectSiteName',
      ellipsis: {
        showTitle: false
      },
      sorter: (a, b) =>
        (a?.ProjectSite?.name || '')?.localeCompare(b?.ProjectSite?.name || ''),
      render: (ProjectSite, record) => {
        const projectSiteName = ProjectSite?.name || record?.ProjectSite?.name;
        return (
          <>
            <Tooltip
              title={projectSiteName || 'N/A'}
              color={'white'}
              overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
              arrowPointAtCenter="false"
            >
              <span className={styles.text_transform}>
                {projectSiteName === null || projectSiteName === undefined
                  ? 'N/A'
                  : projectSiteName}
              </span>
            </Tooltip>
          </>
        );
      }
    },
    {
      title: 'Status',
      dataIndex: 'isDeclared',
      key: 'isDeclared',
      //width: '120px',
      ellipsis: true,
      //sorter: (a, b) => a?.status?.localeCompare(b?.status),
      render: (isDeclared, record) => (
        <Tag
          className={`${styles.status_style}`}
          color={
            record?.isDeclared === true
              ? 'green'
              : record?.isDeclared === false
              ? 'red'
              : 'transparent'
          }
        >
          {record?.isDeclared === true ? 'Declared' : 'Not Declared'}
        </Tag>
      )
    },
    {
      title: 'Action',
      key: '',
      width: 180,
      render: (record) => {
        const isDateValid = isDateInRange(
          record?.upldFrmDate,
          record?.upldToDate
        );
        const isDisabled = record?.isDeclared === true || !isDateValid;

        return (
          <Space size="middle">
            <Button
              className={`${styles.bulk_upload_button}`}
              onClick={() => {
                navigate('/create-declaration-form', {
                  state: { declarationRecord: record }
                });
              }}
              disabled={isDisabled}
            >
              Declare
            </Button>
          </Space>
        );
      }
    }
  ];

  let locale = {
    emptyText: (
      <span>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        <div className={styles.empty_state_text}>
          There are no Bulk Gift Configs to display
        </div>
      </span>
    )
  };

  return (
    <>
      <div className={`${styles.container}`}>
        <Row className={`${styles.row_container}`}>
          <div className={`${styles.gift_container}`}>
            <div className={`${styles.myGift_title}`}>
              Configure Declaration Gifts
            </div>
            <div className={`${styles.myGift_text}`}>
              View and manage Declaration Gifts
            </div>
          </div>

          <Row>
            <Button
              style={{ marginLeft: '20px' }}
              className={`${styles.declareGift_button}`}
              icon={<ArrowLeftOutlined />}
              onClick={() => history.push('/welcome')}
            >
              Back
            </Button>
          </Row>
        </Row>
        <div className={`${styles.tabs_container}`}>
          <Row>
            {/* className={`${styles.row_container}`} */}
            <Col span={16}>
              <Radio.Group
                value={radiofilter}
                size="small"
                className={`${styles.button_import_style}`}
              >
                {filters.map((item, index) => {
                  return (
                    <Radio.Button
                      value={item.value}
                      key={index}
                      //className={`${styles.RadioButton_import_style}`}
                      onChange={() => {
                        window.localStorage.setItem(
                          'set_Radiofilter',
                          JSON?.stringify(item.value)
                        );
                        setRadiofilter(item.value);
                        setTriggerFilter(true);
                      }}
                    >
                      {item.name}
                    </Radio.Button>
                  );
                })}
              </Radio.Group>
            </Col>
            <Col span={8}>
              <SearchBar
                onChange={(e) => {
                  setSearchRequest(e.target.value);
                  setTriggerFilter(true);
                }}
                className={` ${styles.searchbar}`}
                inputProps={{
                  placeholder: 'Search by declaration fiscal year'
                }}
              />
            </Col>
          </Row>
        </div>
        <Card className={`${styles.cardStyles}`}>
          <div className={`${styles.table_container}`}>
            <CustomTable
              columns={columns}
              dataSource={adminBulkGiftConfigs || []}
              locale={locale}
              loading={adminBulkGiftConfigsLoading}
              pagination={{
                current: page,
                pageSize: pageSize,
                showSizeChanger: true,
                size: 'small',
                total: pagination?.total_records || pagination?.total || 0,
                onChange: (page, pageSize) => {
                  setPage(page);
                  setPageSize(pageSize);
                }
              }}
            />
          </div>
        </Card>
      </div>
    </>
  );
}
export default DeclarationFormPage;
